import * as React from "react"
import {
  Create,
} from "react-admin"
import LogoForm from "./LogoForm"

const LogoTitle = () => {
  return <span>{'LOGO'}</span>;
};

const LogoCreate = () => {
  return (
    <Create 
      title={<LogoTitle/>}
    >
      <LogoForm 
        formType="create"
      />
    </Create>
  )
}

export default LogoCreate